import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Polygon3D extends Primitive {
    points;
    constructor(points) {
        super(Type.Polygon3D);
        this.points = points;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9seWdvbjNELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9Qb2x5Z29uM0QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBSTlCLE1BQU0sT0FBTyxTQUFVLFNBQVEsU0FBUztJQUN0QyxNQUFNLENBQVc7SUFFakIsWUFBWSxNQUFpQjtRQUMzQixLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFBO1FBQ3JCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO0lBQ3RCLENBQUM7Q0FDRiJ9